import { useGetAccountQuery } from '@/services/accounts';
import { useGetQuotesQuery } from '@/services/quotes';
import { Box } from '@palmetto/palmetto-components';
import { useParams } from 'react-router-dom';

import { AdderDetails, QuoteStatus, SystemComponent } from 'types';

import { useGetAddersQuery } from '../../services/adders';
import { useGetCurrentDesignQuery } from '../../services/systemDesign';
import FormSection from '../Forms/FormSection';
import { SkeletonBox } from '../SkeletonBox';

import { InverterAndAddersList } from './InverterAndAddersList';

export const InverterAndAddersInformation = () => {
  const { id } = useParams<{ id: any }>();
  const { data: adders } = useGetAddersQuery(id);
  const { data: account } = useGetAccountQuery(id);
  const programType = account?.programType;
  const { data: systemDesign, isLoading: isSystemLoading } = useGetCurrentDesignQuery(
    { id, programType },
    { skip: !programType },
  );

  const { data: quotes } = useGetQuotesQuery({ id, programType }, { skip: !programType });
  const activeQuote = quotes?.find((quote) => quote.status === QuoteStatus.active);
  const hasAdders = activeQuote?.adders?.length > 0;

  return (
    <Box>
      <FormSection title="Inverter Information" className={(adders?.adders?.length ?? 0) > 0 ? 'border-out' : ''}>
        {!systemDesign && isSystemLoading ? (
          <FormSection title="Loading...">
            <SkeletonBox height="25px" width="100" />
          </FormSection>
        ) : (
          systemDesign?.inverters?.map((inverter: SystemComponent, index: number) => (
            <InverterAndAddersList key={index} position={index} inverter={inverter} />
          ))
        )}
      </FormSection>
      {hasAdders && (adders?.adders?.length ?? 0) > 0 && (
        <FormSection title="Adders Information">
          {adders?.adders?.map((adder: AdderDetails, index: number) => (
            <InverterAndAddersList key={index} position={index} adders={adder} />
          ))}
        </FormSection>
      )}
    </Box>
  );
};
